export default resourceName => ({
    data() {
        return {
            columns: [],

        };
    },
    methods: {
        columnFor(name, options = {}) {
            return {
                title: this.$t(name),
                dataIndex: name,
                key: name,
                ...(options.filterable !== false && {
                    scopedSlots: {
                        filterDropdown: 'filterDropdown',
                        filterIcon: 'filterIcon',
                    },
                    onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
                }),
                ...(options.sortable !== false && { sorter: () => {} }),
                sortDirections: ['descend', 'ascend'],
                ...options,
            };
        },
        handleTableChange(props) {
            this.$emit('change', props);
        },
        onFilterDropdownVisibleChange(visible) {
            if (!visible) {
                return;
            }

            setTimeout(() => {
                this.$refs.table.searchInput.focus();
            }, 0);
        },
        customRow(resource) {
            return {
                class: {
                    'cursor-pointer': true,
                },
                on: {
                    click: () => {
                        const mutation = `${resourceName}/CRUD_SET_RESOURCE`;

                        this.$store.commit(mutation, resource);

                        this.$router.push({
                            name: `${resourceName}.view`,
                            params: { id: resource.id },
                        });
                    },
                },
            };
        },
    },
});
